import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { HttpClient } from '@angular/common/http';
import { mimeTypes } from '@shared/constants/mime-types';
import { tap } from 'rxjs';
import {
  downloadFile,
  getFilenameFromContentDisposition,
} from '@shared/utils/download-file';
import { Environment } from '../../types/environment';
import { Attachment } from '../../types/attachment';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  API = this.env.apiUrl;
  constructor(
    @Inject(APP_ENVIRONMENT) private readonly env: Environment,
    private readonly http: HttpClient,
  ) {}

  attach(cargoId: Nullable<number>, id: Nullable<number>, formData: FormData) {
    let url = `${this.API}/attachment/attach?`;
    if (id) {
      url += `&id=${id}`;
    }
    if (cargoId) {
      url += `&cargoId=${cargoId}`;
    }
    return this.http.post<number>(url, formData);
  }

  getFileListFromAttachment(cargoId: Nullable<number>, id: number) {
    let url = `${this.API}/attachment/getFileListFromAttachment?id=${id}`;
    if (cargoId) {
      url += `&cargoId=${cargoId}`;
    }
    return this.http.get<Attachment[]>(url);
  }

  download(cargoId: Nullable<number>, id: number) {
    let url = `${this.API}/attachment/download?id=${id}`;

    if (cargoId) {
      url += `&cargoId=${cargoId}`;
    }
    return this.http
      .get(url, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap(res => {
          if (res.body) {
            const name = getFilenameFromContentDisposition(
              res.headers.get('content-disposition'),
            );
            downloadFile({
              data: res.body,
              type: mimeTypes.APPLICATION_ZIP,
              name,
            });
          }
        }),
      );
  }

  delete(cargoId: Nullable<number>, id: number) {
    let url = `${this.API}/attachment/delete?id=${id}`;
    if (cargoId) {
      url += `&cargoId=${cargoId}`;
    }
    return this.http.post(url, null);
  }

  downloadByCargoId(cargoId: number) {
    return this.http
      .get(`${this.API}/attachment/downloadByCargoId?cargoId=${cargoId}`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap(res => {
          if (res.body) {
            const name = getFilenameFromContentDisposition(
              res.headers.get('content-disposition'),
            );
            downloadFile({
              data: res.body,
              type: mimeTypes.APPLICATION_ZIP,
              name,
            });
          }
        }),
      );
  }

  getSingleFile(params: {
    cargoId: Nullable<number>;
    id: number;
    fileName: string;
  }) {
    let url = `${this.API}/attachment/downloadSingleFile?id=${params.id}&fileName=${params.fileName}`;
    if (params.cargoId) {
      url += `&cargoId=${params.cargoId}`;
    }
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
